import { render } from "./FeedbackPage-View.vue?vue&type=template&id=652c4372&scoped=true"
import script from "./FeedbackPage-View.vue?vue&type=script&lang=js"
export * from "./FeedbackPage-View.vue?vue&type=script&lang=js"

import "./FeedbackPage-View.vue?vue&type=style&index=0&id=652c4372&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652c4372"]])

export default __exports__